module.exports = __webpack_public_path__ + "454593bf338e56a4e27b38395fd89ec2.svg";